module.exports = __webpack_public_path__ + "img/ic_menu.a447e45b.svg";